import { Component, OnInit, HostListener } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  windowsWidth;

  expanded1: false;
  expanded2: false;
  expanded3: false;
  expanded4: false;
  expanded5: false;
  expanded6: false;
  expanded7: false;
  expanded8: false;
  expanded9: false;
  expanded10: false;

  disclaimerActive = false;
  termOfUseActive = false;
  privacyActive = false;
  newsletterActive = false;

  soundIcon = false;
  imageIcon = '../cinemaissue/assets/images/Sound_for_home_with_cross.svg';

  playing;

  constructor() { }

  ngOnInit() {
    this.windowsWidth = window.innerWidth;
    this.playing = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowsWidth = window.innerWidth;
  }

  pauseAndPlayAudio() {
    if (this.playing === false) {
      this.playing = true;
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).play();
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).autoplay = true;
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).loop = true;
      this.soundIcon = !this.soundIcon;
      if (this.imageIcon === '../cinemaissue/assets/images/Sound_for_home_with_cross.svg') {
        this.imageIcon = '../cinemaissue/assets/images/Sound_for_home.svg';
      } else {
        this.imageIcon = '../cinemaissue/assets/images/Sound_for_home_with_cross.svg';
      }
    } else {
      this.soundIcon = !this.soundIcon;
      if (this.imageIcon === '../cinemaissue/assets/images/Sound_for_home.svg') {
        this.imageIcon = '../cinemaissue/assets/images/Sound_for_home_with_cross.svg';
      } else {
        this.imageIcon = '../cinemaissue/assets/images/Sound_for_home.svg';
      }
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).pause();
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).autoplay = false;
      (document.querySelector('#verveGIFTrack') as HTMLMediaElement).loop = false;
      this.playing = false;
    }
  }

}
